import { render, staticRenderFns } from "./GestioneDisponibilita.vue?vue&type=template&id=1157b192&scoped=true"
import script from "./GestioneDisponibilita.vue?vue&type=script&lang=js"
export * from "./GestioneDisponibilita.vue?vue&type=script&lang=js"
import style0 from "./GestioneDisponibilita.vue?vue&type=style&index=0&id=1157b192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1157b192",
  null
  
)

export default component.exports